import { Component } from 'preact'
import Header from '../../header'
import AlertComponent from '../../ui-components/AlertComponent'
import Panel from '../../panel'
import InputGroup from '../../ui-components/InputGroup'
import Permissions from './Permissions'
import CategoryType from './CategoryType'
import IncludeForStats from './IncludeForStats'
import Attachments from './Attachments'
import ConfirmationModal from '../../ui-components/ConfirmationModal'
import CategoryContentCurationManager from '../../content-curation/CategoryContentCurationManager'
import actionTracker from './actionTracker'

const NEWS_CATEGORY_TYPE = 3

class CategoryForm extends Component {
  constructor (props) {
    super()
    this.state = {
      messageType: null,
      errors: [],
      category: props.category,
      showModal: false,
      showConfirmation: false,
      isLoading: false,
      showError: false,
      successMessage: ''
    }
    this.saveCategory = this.saveCategory.bind(this)
    this.setValue = this.setValue.bind(this)
    this.isParentCategory = this.isParentCategory.bind(this)
    this.disableCreatePermissionsList = ['roles.not-activated', 'roles.requires-approval', 'roles.guest', 'roles.banned']
    this.deleteCategory = this.deleteCategory.bind(this)
    this.getDeleteConfirmationTitle = this.getDeleteConfirmationTitle.bind(this)
    this.getDeleteConfirmationText = this.getDeleteConfirmationText.bind(this)
    this.getDeleteConfirmationButtons = this.getDeleteConfirmationButtons.bind(this)
    this.closeConfirmationDialog = this.closeConfirmationDialog.bind(this)
    this.updatePermissions = this.updatePermissions.bind(this)
  }

  saveCategory () {
    const newData = JSON.parse(JSON.stringify(this.state.category))
    let errors = []

    if (!newData.title || newData.title === '') {
      errors.push('title')
    }
    if (!newData.description || newData.description === '') {
      errors.push('description')
    }
    if (errors.length) {
      this.setState({ errors })
      return
    }
    newData.contentCuration.curatedTopics = this.state.category.contentCuration.curatedTopics.map(t => t.id)
    this.request('POST', newData, (result) => {
      if (newData.parentId) {
        actionTracker(newData)
      }

      this.setState({ messageType: 'success' })
      window.location.assign(this.props.overviewLink)
    }, () => {
      this.setState({ messageType: 'error' })
    })
  }

  request (method, data, onSuccess, onFailure) {
    this.setState({ isLoading: true })
    const xhr = new window.XMLHttpRequest()

    xhr.onreadystatechange = (evt) => {
      if (xhr.readyState === 4) {
        if (evt.target.status >= 200 && evt.target.status < 400) {
          onSuccess()
        } else {
          onFailure()
        }
      }
      this.setState({ isLoading: false })
    }
    xhr.open(method, window.location.href, true)
    xhr.send(JSON.stringify(data))
  }

  deleteCategory () {
    this.request('DELETE', { id: this.state.category.id }, () => {
      this.setState({ messageType: 'success' })
      window.location.assign(this.props.overviewLink)
    }, () => {
      this.setState({ messageType: 'error' })
    })
  }

  isParentCategory () {
    return this.state.category.parentId === null
  }

  isNew () {
    return this.state.category.id === null
  }

  setValue (key, value) {
    const category = Object.assign({}, this.state.category, { [key]: value })
    this.setState({ category, errors: [] })

    if (key === 'type') {
      if (category.type === NEWS_CATEGORY_TYPE) {
        this.updatePermissions(this.props.newsAccessRules)
      } else {
        this.updatePermissions(this.props.roles)
      }
    }
  }

  componentDidMount () {
    this.updatePermissions(this.props.roles)
  }

  updatePermissions (accessRules) {
    const mainList = [].concat(accessRules.main)
    const updatedMainList = mainList.reverse().reduce((accumulator, currentValue) => {
      if (this.disableCreatePermissionsList.indexOf(currentValue.role) !== -1) {
        currentValue.create_topics = false
        currentValue.create_posts = false
      }
      return [currentValue].concat(accumulator)
    }, [])

    const concatList = [].concat(updatedMainList).concat(accessRules.custom)
    this.setValue('permissions', concatList)
  }

  closeConfirmationDialog () {
    this.setState({ showConfirmation: false, showError: false })
  }

  canBeDeleted () {
    return this.state.category.visibleSubCategories === 0 && this.state.category.visibleTopics === 0
  }

  getDeleteConfirmationTitle () {
    if (this.canBeDeleted()) {
      return `Delete ${this.isParentCategory() ? 'parent' : ''} category "${this.state.category.title}"`
    }

    return `${this.isParentCategory() ? 'Parent category' : 'Category'} is not empty yet`
  }

  getDeleteConfirmationText () {
    if (this.canBeDeleted()) {
      return "Be careful, once it's deleted, it's gone for good!"
    }

    if (this.isParentCategory()) {
      return <div>
        If you're absolutely sure you want to delete it, you'll need to remove all of its <strong>{this.state.category.visibleSubCategories} categories</strong> by going to <a href={this.props.overviewLink}>{this.props.isKnowledgeBase ? 'Knowledge Base' : 'Category Structure'}</a>, first.
      </div>
    }

    return <div>
      If you're absolutely sure you want to delete it, you'll need to move all of its <strong>{this.state.category.visibleTopics} topics</strong> a different category or delete them.
    </div>
  }

  getDeleteConfirmationButtons () {
    if (!this.canBeDeleted()) {
      return [{
        text: 'Okay',
        callback: this.closeConfirmationDialog,
        class: 'btn btn-primary',
        showLoading: false
      }]
    }
    return [
      {
        text: 'Delete',
        callback: this.deleteCategory,
        class: 'btn btn-danger',
        showLoading: true
      },
      {
        text: 'Cancel',
        callback: this.closeConfirmationDialog,
        class: 'btn btn-default',
        showLoading: false
      }
    ]
  }

  render (props, state) {
    return (
      <div className='category-add_container'>
        <Header
          title={props.pageTitle}
          disableCancelButton
          disableSaveButton
          customButtons={[<div className={'btn btn-cancel js-cancel'} onClick={() => { window.location.assign(props.overviewLink) }}>
            Cancel
          </div>, ' ', this.isNew() ? null : <div className={'btn btn-danger js-delete'} onClick={() => this.setState({ showConfirmation: true })}>
            Delete
          </div>, ' ', <div className={'btn btn-success js-submit'} onClick={() => this.saveCategory()}>
            Save
          </div>]}
        />
        <AlertComponent messageType={state.messageType} />
        <Panel title='Details'>
          <form>
            <InputGroup
              title='Title'
              placeholder='Add a title'
              type={'text'}
              error={state.errors.indexOf('title') !== -1 ? 'Please fill in this field' : ''}
              onChange={(e) => this.setValue('title', e.target.value)}
              value={state.category.title} />
            <InputGroup
              title='Description'
              placeholder='Add a description'
              error={state.errors.indexOf('description') !== -1 ? 'Please fill in this field' : ''}
              type={'text'}
              onChange={(e) => this.setValue('description', e.target.value)}
              value={state.category.description} />
            {
              !this.isParentCategory() ? (
                <IncludeForStats
                  enable={state.category.includeForStats}
                  onUpdate={(value) => this.setValue('includeForStats', value)}
                />
              ) : null
            }
            {
              !props.isKnowledgeBase && !this.isParentCategory() ? (
                <CategoryType
                  currentType={state.category.type}
                  onUpdate={(value) => this.setValue('type', value)}
                />
              ) : null
            }
            {
              !props.isKnowledgeBase && this.isParentCategory() ? (
                <div className={`form-group show_description ${props.isKnowledgeBase ? 'is-hidden' : ''}`}>
                  <input type='checkbox' name='show_description' id='show_description' checked={state.category.showDescriptionOnHomepage} onChange={() => this.setValue('showDescriptionOnHomepage', !state.category.showDescriptionOnHomepage)} />
                  <label htmlFor='show_description'>Show description in category list on homepage.</label>
                </div>
              ) : null
            }
            <Attachments
              label='Hero image'
              className='hero-image'
              meta={
                <div>
                  <div>Hero image will be shown on top of the category page.</div>
                  <div>Maximum file size: 5MB. Allowed image types: .jpg, .png, .gif. We recommend a minimum of 2880*480px</div>
                </div>
              }
              isAttachmentSelected={state.category.heroImage}
              imageSrc={state.category.heroImage && state.category.heroImage.source_thumb}
              width={2880}
              height={480}
              onUpdate={(data) => this.setValue('heroImage', data)}
            />
            {
              !this.isParentCategory() ? (
                <Attachments
                  label='Thumbnail image'
                  className='thumbnail-image'
                  meta={
                    <div>
                      <div>Allowed image types: .jpg, .png, .gif. We recommend a minimum of 144*144px</div>
                    </div>
                  }
                  isAttachmentSelected={state.category.thumbnailImage}
                  imageSrc={state.category.thumbnailImage && state.category.thumbnailImage.source_thumb}
                  width={144}
                  height={144}
                  onUpdate={(data) => this.setValue('thumbnailImage', data)}
                />
              ) : null
            }
            {
              props.isKnowledgeBase && this.isParentCategory() ? (
                <Attachments
                  label='Category card image'
                  className='thumbnail-image'
                  meta={
                    <div>
                      <div>Category card image will be shown on category cards on homepage.</div>
                      <div>Maximum file size: 5MB. Allowed image types: .jpg, .png. We recommend a minimum of 720*272px</div>
                    </div>
                  }
                  isAttachmentSelected={state.category.thumbnailImage}
                  imageSrc={state.category.thumbnailImage && state.category.thumbnailImage.source_thumb}
                  width={720}
                  height={272}
                  onUpdate={(data) => this.setValue('thumbnailImage', data)}
                />
              ) : null
            }
          </form>
        </Panel>
        {
          !props.isKnowledgeBase && !this.isParentCategory() ? (
            <Panel title='Curated content'>
              <CategoryContentCurationManager
                description='Display a list of curated content, such as articles, tutorials and guides to help users find their answers quickly.'
                contentCuration={state.category.contentCuration}
                onChange={(value) => this.setValue('contentCuration', { ...state.category.contentCuration, ...value })}
              />
            </Panel>
          ) : null
        }
        {
          !this.isParentCategory() ? (
            <Panel title='Permissions'>
              <Permissions
                isKnowledgeBase={props.isKnowledgeBase}
                isNews={state.category.type === NEWS_CATEGORY_TYPE}
                mainCount={this.props.roles.main.length}
                disableCreatePermissionsList={this.disableCreatePermissionsList}
                permissions={state.category.permissions || []}
                onUpdate={(data) => this.setValue('permissions', data)}
              />
            </Panel>
          ) : null
        }
        <ConfirmationModal
          isLoading={state.isLoading}
          showError={state.showError}
          enableModal={state.showConfirmation}
          title={this.getDeleteConfirmationTitle()}
          message={this.getDeleteConfirmationText()}
          buttons={this.getDeleteConfirmationButtons()}
          onClose={() => this.setState({ showConfirmation: false })}
        />
      </div>
    )
  }
}

export default CategoryForm
